
export class ServiceRequest {
  public id: number;
  public subject?: string;
  public message: string;
  public phone?: string;
  public files = [];
  public serviceSubject?: any;
  public serviceSubjectItems?: any;
  public order?: number;
}
